import { Component, Input } from "@angular/core";
import { GatewayView } from "../gateway-view";
import { Gateway } from "@impulse/sdp-shared-models";
import { TranslateService } from "app/common/translate";

@Component({
	selector: "sdp-gateway-table-dns",
	template: "<p>{{ hosts.join(', ') }}</p>"
})
export class GatewayTableDnsComponent {
	@Input()
	public gateway?: GatewayView;

	constructor(
		private translateService: TranslateService
	) { }

	/**
	 * @returns an array of just the hosts from the private gateway, or an empty array if no such data is mapped to this component
	 */
	public get hosts(): Gateway.Host[] {
		const hosts: string[] = [];
		if (!!this.gateway) {
			if (this.gateway.dnsEnabled) {
				hosts.push(this.gateway.dnsServer1);
				if (!!this.gateway.dnsServer2) {
					hosts.push(this.gateway.dnsServer2);
				}
			} else {
				hosts.push(this.translateService.translate("privategateway.dns.disabled"));
			}
		}
		return hosts;
	}
}
